import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=068073d4&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=068073d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068073d4",
  null
  
)

export default component.exports